import { PracticeType } from '../../mdqx-graphql-types';

export class PracticeTypeEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(practiceTypeType?: PracticeType | null) {
        if (practiceTypeType && practiceTypeType.id != null && practiceTypeType.name != null) {
            this.Id = practiceTypeType.id;
            this.Name = practiceTypeType.name;
        } else {
            console.error('Received broken PracticeTypeType', practiceTypeType);
            throw Error();
        }
    }
}
